import { NavLink, Outlet } from "react-router-dom"

import { SCORING_TABS } from "@/components/layout/nav"
import { PageHeader } from "@/components/layout/page-header"
import { useActiveTabInView } from "@/components/layout/tab-strip"
import { cn } from "@/lib/utils"

export function ScoringLayout() {
  const strip = useActiveTabInView<HTMLElement>()

  return (
    <>
      <PageHeader
        title="Scoring Engine"
        tabs={
          /*
           * `overflow-x-auto` + `whitespace-nowrap` ниже: на 360px вкладки не
           * помещались в строку, «Default rules» и «Custom rules»
           * ломались на два слова, а соседние однословные повисали ниже по
           * базовой линии — ряд читался как съехавший. Теперь ряд один, лишнее
           * уезжает горизонтальным скроллом внутри самой полосы вкладок.
           */
          <nav
            ref={strip}
            aria-label="Scoring Engine tabs"
            className="-mb-px flex items-end gap-1 overflow-x-auto"
          >
            {SCORING_TABS.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                // Вкладка Dashboard живёт на `/scoring` — без `end` она
                // оставалась бы подсвеченной на двух других.
                end={tab.path === "/scoring"}
                className={({ isActive }) =>
                  cn(
                    "shrink-0 whitespace-nowrap border-b-2 px-2.5 pb-2 text-sm font-medium transition-colors duration-150 ease-snap",
                    isActive
                      ? "border-accent text-accent"
                      : "border-transparent text-fg-muted hover:text-fg",
                  )
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        }
      />
      <Outlet />
    </>
  )
}
